// eslint-disable-next-line object-curly-newline
import { useState } from 'react';
import { Switch, useRouteMatch } from 'react-router';
import { SkuStockReport } from '../../../Pages/Analytics/Inventory Analytics/SkuStockReport';
import CRUDRoutes from '../../CRUD Routes/CRUD.routes';
import { ImsStockFilter } from '@/Components/ImsStockFilter';

const SkuStockReportRoutes = (props) => {
	const { type } = props;
	const { path } = useRouteMatch();
	const [filters, setFilters] = useState({});
	const [stockDeficit, setStockDeficit] = useState(false);
	const [search, setSearch] = useState('');
	const [assetId, setAssetId] = useState('');
	const [assetName, setAssetName] = useState('');
	return (
		<Switch>
			<CRUDRoutes
				path={path}
				entity='SKU STOCK REPORT'
				showSearchBar={false}
				listPage={(...args) => {
					return (
						<SkuStockReport
							stockDeficit={stockDeficit}
							assetId={assetId}
							skuType={filters?.skuType}
							{...args[0]}
							type={type}
							selectedStore={filters?.store?.id}
							search={search}
							assetName={assetName}
						/>
					);
				}}
				listFilter={(
					<ImsStockFilter
						filters={filters}
						setFilters={setFilters}
						stockDeficit={stockDeficit}
						setStockDeficit={setStockDeficit}
						type={type}
						search={search}
						setSearch={setSearch}
						assetId={assetId}
						setAssetId={setAssetId}
						setAssetName={setAssetName}
					/>
				)}
			/>
		</Switch>
	);
};

export default SkuStockReportRoutes;
